import { isArray } from 'lodash';
import { ELSInlineLoader } from '@els/els-ui-common-react';
export var TrueStatement = function (_a) {
    var children = _a.children;
    return <>{children}</>;
};
export var FalseStatement = function (_a) {
    var children = _a.children;
    return <>{children}</>;
};
var getStatement = function (children, statement) {
    return (children || []).find(function (child) { return child.type === statement; });
};
var ConditionSection = function (_a) {
    var condition = _a.condition, children = _a.children, _b = _a.withLoading, withLoading = _b === void 0 ? true : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c;
    if (isLoading) {
        return <ELSInlineLoader />;
    }
    if (isArray(children)) {
        var trueStatement = getStatement(children, TrueStatement);
        var falseStatement = getStatement(children, FalseStatement);
        if (condition) {
            return <>{trueStatement}</>;
        }
        return <>{falseStatement}</>;
    }
    if (condition) {
        if (withLoading) {
            return <ELSInlineLoader />;
        }
        return <></>;
    }
    return <>{children}</>;
};
ConditionSection.TrueStatement = TrueStatement;
ConditionSection.FalseStatement = FalseStatement;
export default ConditionSection;
